import { FORGET_USER, FORGET_USER_SUCCESSFUL, FORGET_PASSWORD_API_FAILED, UPDATE_PW, UPDATE_PW_SUCCESSFUL, UPDATE_PW_FAILED, RESET_FORGOT_PW_STATE } from './actionTypes';

export const forgetUser = (user) => {
  
    return {
        type: FORGET_USER,
        payload: user
    }
}

export const forgetUserSuccessful = (message) => {
    return {
        type: FORGET_USER_SUCCESSFUL,
        payload: message
    }
}

export const userForgetPasswordError = (error) => {
    return {
        type: FORGET_PASSWORD_API_FAILED,
        payload: error
    }
}
export const updatePW = (user) => {
  
    return {
        type: UPDATE_PW,
        payload: { user }
    }
}

export const updatePWSuccessful = (message) => {
    return {
        type: UPDATE_PW_SUCCESSFUL,
        payload: message
    }
}

export const updatePWError = (error) => {
    return {
        type: UPDATE_PW_FAILED,
        payload: error
    }
}


export const resetForgetPWState = () => {
    return {
         type: RESET_FORGOT_PW_STATE,
         playload:{}
    }
}
